import React, { isValidElement, cloneElement, Children } from "react";
import classNames from "classnames";
import { IndexSectionProps } from "./PropsType";

export default function IndexSection(props: IndexSectionProps) {
  const {
    children: childrenProps,
    className,
    index: indexProps,
    prefixCls = "bm-IndexSection",
  } = props;
  const styleClass = classNames(prefixCls, className);
  const children = Children.map(
    childrenProps,
    (child: any, index: number) => {
      if (!isValidElement(child)) {
        return null;
      }
      return (
        <li key={index} className={`${prefixCls}-item`}>
          {cloneElement(child, child.props || {})}
        </li>
      );
    }
  );
  return (
    <li className={styleClass}>
      <p className={`${prefixCls}-title`} data-index={indexProps}>
        {indexProps}
      </p>
      <ul>{children}</ul>
    </li>
  );
}
